// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Noto Sans KR', sans-serif;
  background-color: #fff;
  color: #111;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 32px;
  border-bottom: 1px solid #ccc;
  background-color: white;
}

.navbar .logo {
  font-weight: bold;
  font-size: 1.4rem;
}

.navbar nav a {
  margin: 0 16px;
  text-decoration: none;
  color: black;
  font-weight: 500;
}

.navbar .auth-buttons button {
  margin-left: 10px;
  padding: 6px 12px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}

.login {
  background: #f0f0f0;
}

.join {
  background: black;
  color: white;
}

main {
  display: flex;
  justify-content: center;
  padding: 40px 16px;
}

.proposal-form {
  width: 100%;
  max-width: 600px;
  padding: 24px;
  background: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.proposal-form label {
  font-weight: 600;
  margin-bottom: 8px;
  display: block;
}

.proposal-form input[type="text"],
.proposal-form select {
  width: 100%;
  padding: 10px;
  margin-bottom: 16px;
  margin-top: -5px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.4;
  box-sizing: border-box;
}

.radio-group {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.duplicate-vote-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.duplicate-vote-settings label {
  margin-bottom: 0;
  font-weight: 600;
  white-space: nowrap;
}

.duplicate-vote-settings select {
  width: 80px;
  padding: 6px 8px;
  font-size: 14px;
}

.options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 16px;
  margin-top: 10px;
}

.option-box {
  position: relative;
}

.option-box input {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  font-size: 14px;
  border: 1.5px solid #ccc;
  border-radius: 8px;
}

.remove-btn {
  position: absolute;
  top: -14px;
  right: -10px;
  background: none !important;
  color: black !important;
  border: none;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  z-index: 10;
  padding: 0;
  line-height: 1;
}

.remove-btn:hover {
  color: red;
}

.proposal-form button {
  display: block;
  margin: 12px auto 0;
  padding: 10px 24px;
  background-color: black;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.options-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 16px;
  margin-bottom: 12px;
  margin-top: 12px;
}
.vote-option-btn {
  width: 100%;
  max-width: 300px;
  padding: 14px 18px;
  border: 2px solid #444;
  border-radius: 10px;
  background: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin: 6px auto;
  display: block;
  text-align: center;
}

.vote-option-btn.selected {
  background: black;
  color: white;
  border-color: black;
  font-weight: bold;
}

.nav-link {
  margin: 0 16px;
  text-decoration: none;
  color: black;
  font-weight: 500;
}

.nav-link.active {
  font-weight: 800;
}
.query-container {
  width: 100%;
  max-width: 700px;
  padding: 24px;
  background: #fafafa;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.query-container h2 {
  font-size: 20px;
  margin-bottom: 16px;
  font-weight: bold;
}

.query-container input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-bottom: 16px;
  font-size: 14px;
}

.query-container button {
  background-color: black;
  color: white;
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
}
.auth-input {
  width: 50%;
  height: 45px;
  padding: 12px 15px;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-bottom: 15px;
  font-size: 14px;
  box-sizing: border-box;
}
.vote-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.vote-list-item {
  padding: 12px 16px;
  border: 1px solid black;
  border-radius: 8px;
  background-color: white;
  color: black;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 10px;
  transition: all 0.2s ease;
}

.vote-list-item:hover {
  background-color: #f5f5f5;
}
.vote-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.vote-card {
  background: #f5f5f5;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.vote-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.vote-topic {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
}

.vote-expired {
  font-size: 14px;
  color: #d9534f;
}

.vote-date {
  font-size: 12px;
  color: #777;
}
.vote-detail-card {
  background: #f5f5f5;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  margin-top: 20px;
}

.vote-detail-card h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}

.vote-detail-card p {
  margin: 5px 0;
}

.vote-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.vote-option {
  padding: 6px 12px;
  background-color: #e3e3e3;
  border-radius: 6px;
  font-weight: 500;
}

.raw-response {
  margin-top: 20px;
  background-color: #f4f4f4;
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
  font-size: 0.9em;
}

.error-message {
  color: red;
  margin-top: 10px;
}
.vote-list {
  list-style: none;
  padding: 0;
}

.vote-list-item {
  cursor: pointer;
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  background: #f0f0f0;
  transition: background-color 0.2s;
}

.vote-list-item:hover {
  background: #e0e0e0;
}

.vote-options {
  margin: 16px 0;
}

.vote-option {
  display: block;
  margin: 12px 0;
  font-size: 15px;
}
.vote-option-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 12px;
}

.vote-option-grid button {
  padding: 14px 0;
  border: 2px solid #444;
  border-radius: 10px;
  background: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.vote-option-grid button.selected {
  background: #000;
  color: #fff;
  border-color: #000;
  font-weight: bold;
}

.success-msg {
  color: green;
  margin-top: 10px;
}

.error-msg {
  color: red;
  margin-top: 10px;
  white-space: pre-wrap;
}
.user-section {
  display: flex;
  align-items: center;
  position: relative;
}

.user-info {
  position: relative;
  margin-right: 10px;
}

.username {
  cursor: pointer;
  font-weight: 500;
  margin-right: 12px;
  text-decoration: underline;
}

.user-dropdown {
  position: absolute;
  top: 28px;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  z-index: 1000;
  min-width: 220px;
}

.user-dropdown p {
  margin: 6px 0;
  font-size: 14px;
}

.user-hash {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.copy-btn {
  margin-left: 8px;
  padding: 2px 6px;
  font-size: 12px;
  border: none;
  border-radius: 4px;
  background: #f0f0f0;
  cursor: pointer;
}

.copy-btn:hover {
  background: #ddd;
}
.proposal-form {
  max-width: 500px;
  margin: 40px auto;
  padding: 20px;
}

.options-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 20px 0;
}

.options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 16px;
  margin-top: 10px;
}

.option-box {
  position: relative;
  width: 100%;
}

.option-box input {
  width: 100%;
  padding: 14px 18px;
  font-size: 16px;
  border: 2px solid #444;
  border-radius: 10px;
  box-sizing: border-box;
}

.option-box.selected {
  background-color: #000;
  color: #fff;
  border-color: #777;
}

.radio-tab {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.radio-tab label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.radio-tab input[type="radio"] {
  margin-right: 5px;
}
.poll-list-vertical {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.poll-card.full-width {
  width: 100%;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #f9f9f9;
  font-size: 16px;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s;
  color: #555;
}

.poll-card.full-width:hover {
  background: #e9e9e9;
}

.poll-card.expired {
  background: #f9f9f9;
  color: #000;
}

.poll-item-wrapper {
  display: flex;
  flex-direction: column;
}

.proposal-detail {
  margin-top: 8px;
  padding: 12px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0px 2px 4px rgba(0,0,0,0.05);
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.pagination button {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #f0f0f0;
  cursor: pointer;
  color: black;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.submit-options-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin: 20px 0;
}

.submit-option-box {
  padding: 14px 0;
  border: 0.5px solid #444;
  border-radius: 10px;
  text-align: center;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background: #fff;
  -webkit-user-select: none;
          user-select: none;
}

.submit-option-box.selected {
  background: #000;
  color: #fff;
  border-color: #000;
}

.back-btn {
  margin-top: 12px;
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  background-color: #444;
  color: white;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s;

  position: relative;
  top: -7px;
}

.back-btn:hover {
  background-color: #000;
}
.options-row {
  display: grid;
  grid-template-columns: 100px 1fr 100px 1fr;
  gap: 10px 16px;
  margin-bottom: 12px;
  align-items: center;
}

.options-row label {
  font-weight: 600;
  white-space: nowrap;
}

.options-row input {
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
}
.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.info-row label {
  width: 100px;
  font-weight: 600;
}

.info-row input {
  flex: 1 1;
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-left: 10px;
  position: relative;
  top: 7px;
}

.hash-box {
  display: flex;
  align-items: center;
  flex: 1 1;
}

.hash-box input {
  flex: 1 1;
  margin-right: 10px;
  height: 40px;
  position: relative;
  top: 7px;
}

.copy-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  background-color: black;
  color: white;
  cursor: pointer;
  position: relative;
  top: -10px;
}

.copy-btn:hover {
  background-color: #333;
}
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
}

.nav-links {
  display: flex;
  flex-wrap: wrap;
  gap: 0px;
  justify-content: center;
  flex: 1 1;
}

.nav-links a {
  text-decoration: none;
  color: black;
  font-weight: 500;
  white-space: nowrap;
  word-break: keep-all;
  display: inline-block;
  padding: 4px 6px;
}

.nav-links a.active {
  font-weight: 800;
}

@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    align-items: center;
  }

  .nav-links {
    justify-content: center;
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .nav-links {
    flex-direction: column;
    gap: 10px;
  }
}
.proposal-form .add-option-btn {
  background-color: #e0e0e0 !important;
  color: #333;
  border: none;
}

.proposal-form .add-option-btn:hover {
  background-color: #d5d5d5 !important;
}
.block-explorer-container {
  width: 100%;
  max-width: 600px;
  background: #f9f9f9;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.radio-group {
  display: flex;
  gap: 20px;
  font-weight: 600;
  font-size: 16px;
}

.block-result table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
}

.block-result th,
.block-result td {
  border: 1px solid #ccc;
  padding: 10px;
  text-align: left;
}

.error-box {
  color: red;
  margin-top: 10px;
}

.block-result table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.block-result th, .block-result td {
  border: 1px solid #ddd;
  padding: 8px;
  vertical-align: top;
  word-break: break-all;
  white-space: normal;
  text-align: left;
}

.block-result th {
  background-color: #f2f2f2;
}
.proposal-form .form-group {
  margin-top: 10px;
}
.salt-label {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 16px;
  margin-bottom: 10px;
}

.salt-title {
  font-weight: 700;
  font-size: 16px;
  display: inline-block;
}
.tooltip-container {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.tooltip-btn {
  all: unset !important;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.tooltip-btn {
  color: #000 !important;
}
.tooltip-btn:hover {
  color: #666 !important;
}

.tooltip-btn svg {
  background: none !important;
  fill: none !important;
  stroke: currentColor !important;
}
.tooltip-content {
  visibility: hidden;
  opacity: 0;
  width: 260px;
  background-color: #333;
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 8px 10px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -130px;
  font-size: 13px;
  transition: opacity 0.3s;
}

.tooltip-container:hover .tooltip-content {
  visibility: visible;
  opacity: 1;
}

.salt-input {
  width: 100%;
  height: 40px;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 16px;
}

.submit-btn {
  display: inline-block;
  min-width: 100px;
  padding: 12px 24px;
  background-color: #000;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
}


.submit-btn:hover {
  background: #222;
}

.back-link {
  margin-top: 10px;
  background: none !important;
  border: none !important;
  color: #555 !important;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  float: right;
  padding: 0;
}

.back-link:hover {
  color: #000 !important;
  text-decoration: underline;
}
.nav-link-tooltip {
  position: relative;
  display: inline-block;
}

.nav-link-tooltip::after {
  content: attr(data-tooltip);
  position: absolute;
  top: 150%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease-in-out;
  z-index: 9999;
}

.nav-link-tooltip:hover::after {
  opacity: 1;
}

.react-datepicker {
  font-size: 13px;
}
.react-datepicker__header {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.react-datepicker__navigation--previous::before,
.react-datepicker__navigation--next::before {
  border-color: #000 !important;
}
.react-datepicker__time-container .react-datepicker__header--time {
  min-height: 61px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.react-datepicker__current-month {
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
}
.react-datepicker__day-name,
.react-datepicker__day {
  width: 28px;
  line-height: 28px;
  font-size: 12px;
}
.react-datepicker__time-list {
  font-size: 12px;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
}

.logo-img {
  width: 38px;
  height: 38px;
  margin-right: 5px;
  transform: translateY(-5px);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,uCAAuC;EACvC,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,2BAA2B;;EAE3B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Noto Sans KR', sans-serif;\n  background-color: #fff;\n  color: #111;\n}\n\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 32px;\n  border-bottom: 1px solid #ccc;\n  background-color: white;\n}\n\n.navbar .logo {\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.navbar nav a {\n  margin: 0 16px;\n  text-decoration: none;\n  color: black;\n  font-weight: 500;\n}\n\n.navbar .auth-buttons button {\n  margin-left: 10px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n}\n\n.login {\n  background: #f0f0f0;\n}\n\n.join {\n  background: black;\n  color: white;\n}\n\nmain {\n  display: flex;\n  justify-content: center;\n  padding: 40px 16px;\n}\n\n.proposal-form {\n  width: 100%;\n  max-width: 600px;\n  padding: 24px;\n  background: #f9f9f9;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n\n.proposal-form label {\n  font-weight: 600;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.proposal-form input[type=\"text\"],\n.proposal-form select {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 16px;\n  margin-top: -5px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 14px;\n  line-height: 1.4;\n  box-sizing: border-box;\n}\n\n.radio-group {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.duplicate-vote-settings {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.duplicate-vote-settings label {\n  margin-bottom: 0;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.duplicate-vote-settings select {\n  width: 80px;\n  padding: 6px 8px;\n  font-size: 14px;\n}\n\n.options-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px 16px;\n  margin-top: 10px;\n}\n\n.option-box {\n  position: relative;\n}\n\n.option-box input {\n  width: 100%;\n  padding: 10px;\n  box-sizing: border-box;\n  font-size: 14px;\n  border: 1.5px solid #ccc;\n  border-radius: 8px;\n}\n\n.remove-btn {\n  position: absolute;\n  top: -14px;\n  right: -10px;\n  background: none !important;\n  color: black !important;\n  border: none;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  z-index: 10;\n  padding: 0;\n  line-height: 1;\n}\n\n.remove-btn:hover {\n  color: red;\n}\n\n.proposal-form button {\n  display: block;\n  margin: 12px auto 0;\n  padding: 10px 24px;\n  background-color: black;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.options-row {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px 16px;\n  margin-bottom: 12px;\n  margin-top: 12px;\n}\n.vote-option-btn {\n  width: 100%;\n  max-width: 300px;\n  padding: 14px 18px;\n  border: 2px solid #444;\n  border-radius: 10px;\n  background: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin: 6px auto;\n  display: block;\n  text-align: center;\n}\n\n.vote-option-btn.selected {\n  background: black;\n  color: white;\n  border-color: black;\n  font-weight: bold;\n}\n\n.nav-link {\n  margin: 0 16px;\n  text-decoration: none;\n  color: black;\n  font-weight: 500;\n}\n\n.nav-link.active {\n  font-weight: 800;\n}\n.query-container {\n  width: 100%;\n  max-width: 700px;\n  padding: 24px;\n  background: #fafafa;\n  border-radius: 12px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n.query-container h2 {\n  font-size: 20px;\n  margin-bottom: 16px;\n  font-weight: bold;\n}\n\n.query-container input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n.query-container button {\n  background-color: black;\n  color: white;\n  padding: 10px 18px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.auth-input {\n  width: 50%;\n  height: 45px;\n  padding: 12px 15px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n.vote-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.vote-list-item {\n  padding: 12px 16px;\n  border: 1px solid black;\n  border-radius: 8px;\n  background-color: white;\n  color: black;\n  font-weight: 600;\n  cursor: pointer;\n  margin-bottom: 10px;\n  transition: all 0.2s ease;\n}\n\n.vote-list-item:hover {\n  background-color: #f5f5f5;\n}\n.vote-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 16px;\n  margin-top: 20px;\n}\n\n.vote-card {\n  background: #f5f5f5;\n  border-radius: 10px;\n  padding: 16px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.vote-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n.vote-topic {\n  font-size: 18px;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.vote-expired {\n  font-size: 14px;\n  color: #d9534f;\n}\n\n.vote-date {\n  font-size: 12px;\n  color: #777;\n}\n.vote-detail-card {\n  background: #f5f5f5;\n  border-radius: 10px;\n  padding: 16px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n  margin-top: 20px;\n}\n\n.vote-detail-card h3 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.vote-detail-card p {\n  margin: 5px 0;\n}\n\n.vote-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.vote-option {\n  padding: 6px 12px;\n  background-color: #e3e3e3;\n  border-radius: 6px;\n  font-weight: 500;\n}\n\n.raw-response {\n  margin-top: 20px;\n  background-color: #f4f4f4;\n  padding: 12px;\n  border-radius: 6px;\n  overflow-x: auto;\n  font-size: 0.9em;\n}\n\n.error-message {\n  color: red;\n  margin-top: 10px;\n}\n.vote-list {\n  list-style: none;\n  padding: 0;\n}\n\n.vote-list-item {\n  cursor: pointer;\n  padding: 12px;\n  margin-bottom: 8px;\n  border-radius: 8px;\n  background: #f0f0f0;\n  transition: background-color 0.2s;\n}\n\n.vote-list-item:hover {\n  background: #e0e0e0;\n}\n\n.vote-options {\n  margin: 16px 0;\n}\n\n.vote-option {\n  display: block;\n  margin: 12px 0;\n  font-size: 15px;\n}\n.vote-option-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.vote-option-grid button {\n  padding: 14px 0;\n  border: 2px solid #444;\n  border-radius: 10px;\n  background: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: center;\n}\n\n.vote-option-grid button.selected {\n  background: #000;\n  color: #fff;\n  border-color: #000;\n  font-weight: bold;\n}\n\n.success-msg {\n  color: green;\n  margin-top: 10px;\n}\n\n.error-msg {\n  color: red;\n  margin-top: 10px;\n  white-space: pre-wrap;\n}\n.user-section {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.user-info {\n  position: relative;\n  margin-right: 10px;\n}\n\n.username {\n  cursor: pointer;\n  font-weight: 500;\n  margin-right: 12px;\n  text-decoration: underline;\n}\n\n.user-dropdown {\n  position: absolute;\n  top: 28px;\n  right: 0;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 12px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n  z-index: 1000;\n  min-width: 220px;\n}\n\n.user-dropdown p {\n  margin: 6px 0;\n  font-size: 14px;\n}\n\n.user-hash {\n  display: inline-block;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n\n.copy-btn {\n  margin-left: 8px;\n  padding: 2px 6px;\n  font-size: 12px;\n  border: none;\n  border-radius: 4px;\n  background: #f0f0f0;\n  cursor: pointer;\n}\n\n.copy-btn:hover {\n  background: #ddd;\n}\n.proposal-form {\n  max-width: 500px;\n  margin: 40px auto;\n  padding: 20px;\n}\n\n.options-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 20px 0;\n}\n\n.options-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px 16px;\n  margin-top: 10px;\n}\n\n.option-box {\n  position: relative;\n  width: 100%;\n}\n\n.option-box input {\n  width: 100%;\n  padding: 14px 18px;\n  font-size: 16px;\n  border: 2px solid #444;\n  border-radius: 10px;\n  box-sizing: border-box;\n}\n\n.option-box.selected {\n  background-color: #000;\n  color: #fff;\n  border-color: #777;\n}\n\n.radio-tab {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.radio-tab label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.radio-tab input[type=\"radio\"] {\n  margin-right: 5px;\n}\n.poll-list-vertical {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.poll-card.full-width {\n  width: 100%;\n  padding: 15px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background: #f9f9f9;\n  font-size: 16px;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.2s;\n  color: #555;\n}\n\n.poll-card.full-width:hover {\n  background: #e9e9e9;\n}\n\n.poll-card.expired {\n  background: #f9f9f9;\n  color: #000;\n}\n\n.poll-item-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.proposal-detail {\n  margin-top: 8px;\n  padding: 12px;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid #ddd;\n  box-shadow: 0px 2px 4px rgba(0,0,0,0.05);\n}\n\n.pagination {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n}\n\n.pagination button {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  background: #f0f0f0;\n  cursor: pointer;\n  color: black;\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.submit-options-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n  margin: 20px 0;\n}\n\n.submit-option-box {\n  padding: 14px 0;\n  border: 0.5px solid #444;\n  border-radius: 10px;\n  text-align: center;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #fff;\n  user-select: none;\n}\n\n.submit-option-box.selected {\n  background: #000;\n  color: #fff;\n  border-color: #000;\n}\n\n.back-btn {\n  margin-top: 12px;\n  padding: 10px 18px;\n  border: none;\n  border-radius: 8px;\n  background-color: #444;\n  color: white;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  position: relative;\n  top: -7px;\n}\n\n.back-btn:hover {\n  background-color: #000;\n}\n.options-row {\n  display: grid;\n  grid-template-columns: 100px 1fr 100px 1fr;\n  gap: 10px 16px;\n  margin-bottom: 12px;\n  align-items: center;\n}\n\n.options-row label {\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.options-row input {\n  width: 100%;\n  height: 40px;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background: #fff;\n}\n.info-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.info-row label {\n  width: 100px;\n  font-weight: 600;\n}\n\n.info-row input {\n  flex: 1;\n  height: 40px;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  margin-left: 10px;\n  position: relative;\n  top: 7px;\n}\n\n.hash-box {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n\n.hash-box input {\n  flex: 1;\n  margin-right: 10px;\n  height: 40px;\n  position: relative;\n  top: 7px;\n}\n\n.copy-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  background-color: black;\n  color: white;\n  cursor: pointer;\n  position: relative;\n  top: -10px;\n}\n\n.copy-btn:hover {\n  background-color: #333;\n}\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 20px;\n}\n\n.nav-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0px;\n  justify-content: center;\n  flex: 1;\n}\n\n.nav-links a {\n  text-decoration: none;\n  color: black;\n  font-weight: 500;\n  white-space: nowrap;\n  word-break: keep-all;\n  display: inline-block;\n  padding: 4px 6px;\n}\n\n.nav-links a.active {\n  font-weight: 800;\n}\n\n@media (max-width: 768px) {\n  .navbar {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .nav-links {\n    justify-content: center;\n    gap: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .nav-links {\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n.proposal-form .add-option-btn {\n  background-color: #e0e0e0 !important;\n  color: #333;\n  border: none;\n}\n\n.proposal-form .add-option-btn:hover {\n  background-color: #d5d5d5 !important;\n}\n.block-explorer-container {\n  width: 100%;\n  max-width: 600px;\n  background: #f9f9f9;\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n\n.radio-group {\n  display: flex;\n  gap: 20px;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.block-result table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 16px;\n}\n\n.block-result th,\n.block-result td {\n  border: 1px solid #ccc;\n  padding: 10px;\n  text-align: left;\n}\n\n.error-box {\n  color: red;\n  margin-top: 10px;\n}\n\n.block-result table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.block-result th, .block-result td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  vertical-align: top;\n  word-break: break-all;\n  white-space: normal;\n  text-align: left;\n}\n\n.block-result th {\n  background-color: #f2f2f2;\n}\n.proposal-form .form-group {\n  margin-top: 10px;\n}\n.salt-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin-top: 16px;\n  margin-bottom: 10px;\n}\n\n.salt-title {\n  font-weight: 700;\n  font-size: 16px;\n  display: inline-block;\n}\n.tooltip-container {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n.tooltip-btn {\n  all: unset !important;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: none !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n}\n\n.tooltip-btn {\n  color: #000 !important;\n}\n.tooltip-btn:hover {\n  color: #666 !important;\n}\n\n.tooltip-btn svg {\n  background: none !important;\n  fill: none !important;\n  stroke: currentColor !important;\n}\n.tooltip-content {\n  visibility: hidden;\n  opacity: 0;\n  width: 260px;\n  background-color: #333;\n  color: #fff;\n  text-align: left;\n  border-radius: 6px;\n  padding: 8px 10px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  margin-left: -130px;\n  font-size: 13px;\n  transition: opacity 0.3s;\n}\n\n.tooltip-container:hover .tooltip-content {\n  visibility: visible;\n  opacity: 1;\n}\n\n.salt-input {\n  width: 100%;\n  height: 40px;\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.submit-btn {\n  display: inline-block;\n  min-width: 100px;\n  padding: 12px 24px;\n  background-color: #000;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 500;\n  border: none;\n  border-radius: 8px;\n  text-align: center;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n\n.submit-btn:hover {\n  background: #222;\n}\n\n.back-link {\n  margin-top: 10px;\n  background: none !important;\n  border: none !important;\n  color: #555 !important;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  float: right;\n  padding: 0;\n}\n\n.back-link:hover {\n  color: #000 !important;\n  text-decoration: underline;\n}\n.nav-link-tooltip {\n  position: relative;\n  display: inline-block;\n}\n\n.nav-link-tooltip::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  top: 150%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.8);\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease-in-out;\n  z-index: 9999;\n}\n\n.nav-link-tooltip:hover::after {\n  opacity: 1;\n}\n\n.react-datepicker {\n  font-size: 13px;\n}\n.react-datepicker__header {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.react-datepicker__navigation--previous::before,\n.react-datepicker__navigation--next::before {\n  border-color: #000 !important;\n}\n.react-datepicker__time-container .react-datepicker__header--time {\n  min-height: 61px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.react-datepicker__current-month {\n  font-weight: bold;\n  font-size: 14px;\n  text-transform: uppercase;\n}\n.react-datepicker__day-name,\n.react-datepicker__day {\n  width: 28px;\n  line-height: 28px;\n  font-size: 12px;\n}\n.react-datepicker__time-list {\n  font-size: 12px;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.logo-img {\n  width: 38px;\n  height: 38px;\n  margin-right: 5px;\n  transform: translateY(-5px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
